import React, { Component } from 'react'
import InputField from '../Elements/InputField'

export default class InputGroup extends Component {
    render() {
        const { title, setValue, error,name, value, icon, id=''} = this.props;

        return (
            <div className="form-group">
                <label htmlFor="FeedFeedsfieldtitle13">{title}</label>
                <div className="input-group">
                    <div className="input-group-prepend">
                        <span className="input-group-text">
                            <i className={`fas fa-${icon}`}></i>
                        </span>
                    </div>
                    <InputField name={name} id={id} className={`mycheck form-control`} placeholder="" value={value} onChangeHandler={setValue}/>
                </div>
                {error ? <span id="" className="errorMessage required">{title == "Feed Url" ? "This field must contain a url." : "This field is required."}</span> : null}
            </div>
        )
    }
}
